module.exports = __webpack_public_path__ + "img/sellerstatus4.793fbc8a.png";